module.exports = __webpack_public_path__ + "img/title.147dd81f.png";